import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./IntelegentVoiceOrderTable.module.scss";
import moment from "moment-jalaali";

const IntelegentVoiceOrderTable = ({ showModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شماره سفارش",
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: "10%",
      ...getColumnSearchProps("orderNumber", "شماره سفارش"),
    },
    {
      title: "شخص",
      dataIndex: "person",
      key: "person",
      width: "14%",
      ...getColumnSearchProps("person", "شخص"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showModal(1, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شهر",
      dataIndex: "city",
      key: "city",
      width: "10%",
      ...getColumnSearchProps("city", "شهر"),
    },
    {
      title: "زمان سفارش",
      dataIndex: "date",
      key: "date",
      width: "15.3%",
      render: (text) => (
        <p style={{ direction: "ltr" }}>
          {moment.unix(parseInt(text)).format("jYYYY/jM/jD--HH:mm")}
        </p>
      ),
    },
    {
      title: "وضعیت ",
      dataIndex: "orderStatus",
      key: "orderStatus",
      width: "13%",
      render: (text, record) => (
        <h2
        //   style={{ color: orderStatusColor[text] }}
          className={Style.statusStyle}
        >
          {/* {orderStatus[text]} */}
        </h2>
      ),
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "25%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showModal(2, record)}
            className={Style.orderBtn}
          >
            نمایش سفارش
          </button>
          {
            <button
              onClick={() => showModal(5, record)}
              className={Style.factorBtn}
            >
              فاکتور جدید
            </button>
          }
          {record.orderStatus === "3" || record.orderStatus === "1.1" ? (
            <button
              onClick={() => showModal(4, record)}
              className={Style.deliverBtn}
            >
              پیک
            </button>
          ) : <span style={{width:"2.5rem"}}></span>}
          {record.wallet_transactions.length !== 0 ? (
            <button
              onClick={() => showModal(3, record)}
              className={Style.walletBtn}
            >
              تراکنشات کیف پول
            </button>
          ) : <span style={{width:"4.5rem"}}></span>}
          {record.orderStatus !== "-1" &&
          record.orderStatus !== "-2" &&
          record.orderStatus !== "-" &&
          record.orderStatus !== "3" ? (
            <button
              onClick={() => showModal(6, record)}
              className={Style.CancelBtn}
            >
              کنسل
            </button>
          ) : <span style={{width:"3rem"}}></span>}
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        loading={data === undefined ? true : false}
        pagination={{
          showSizeChanger:true
        }}
        columns={columns}
        dataSource={data}
        scroll={{ y: 520 }}
        size={"middle"}
        responsive={true}
      />
    </div>
  );
};

export default IntelegentVoiceOrderTable;
